<template>
  <div>
    <input type="file" multiple @change="detectFiles($event.target.files)">
    <div class="progress-bar" :style="{ width: progressUpload + '%'}">{{ progressUpload }}%</div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  data () {
    return {
      progressUpload: 0,
      file: File,
      uploadTask: '',
      db: null
    }
  },
  mounted () {
    firebase.auth()
      .onAuthStateChanged((user) => {
        this.user = firebase.auth().currentUser
        this.db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        this.db.settings(settings)
      })
  },
  methods: {
    detectFiles (fileList) {
      if (!this.user) return
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload (file) {
      this.db.collection('files').add({
        user: this.user.uid,
        file: `${this.user.uid}/${file.name}`
      })

      this.uploadTask = firebase.storage().ref(`${this.user.uid}/${file.name}`).put(file)
    }
  },
  watch: {
    uploadTask () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.$emit('url', downloadURL)
        })
      })
    }
  }
}
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUpload.vue